import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ErreurQuantiteDialogContent from './ErreurQuantiteDialogContent';
import withLoader from 'components/Shared/withLoader';
import { fetchReclamationQualificationsIfNeeded } from 'store/reclamation/detailsActions';
import { sansDepotMagasin } from 'utils/depotHelper';

const ErreurQuantiteDialogContentWithLoader = withLoader(ErreurQuantiteDialogContent);

class ErreurQuantiteDialogContentContainer extends React.Component {
    
    async componentDidMount() {
        await this.props.fetchReclamationQualificationsIfNeeded(this.props.reclamationId);
    }

    render() {
        const { onChange, action, isLoading, articles, reclamationMagasin } = this.props;

        let codeDepot = reclamationMagasin ? reclamationMagasin.codeDepot : '';
        if (codeDepot === '') {
            let utilisateur = JSON.parse(localStorage.getItem('utilisateur'));

            if (sansDepotMagasin(utilisateur)) {
                if (utilisateur.depots && utilisateur.depots.length === 1) {
                    codeDepot = utilisateur.depots[0].code;
                }
            }
            else {
                codeDepot = utilisateur.depot.code;
            }
        }

        return (
        <ErreurQuantiteDialogContentWithLoader
            isLoading={isLoading}
            onChange={onChange}
            action={action}
            codeDepot={codeDepot}
            articles={articles}
        />);
    }
}

ErreurQuantiteDialogContentContainer.propTypes = {
    onChange: PropTypes.func.isRequired,
    action: PropTypes.object.isRequired
};

const mapStateToProps = (state, props) => ({
    articles: state.reclamation.details && state.reclamation.details.qualifications && state.reclamation.details.qualifications.lignes
        ? state.reclamation.details.qualifications.lignes.map(x => { return { codeArticle: x.codeArticleCommande, quantite: x.quantiteCommande, quantiteRecue: x.quantiteAnomalie, designation: x.designationArticleCommande, typeAnomalie: x.typeAnomalie }; })
        : [],
    reclamationMagasin: state.reclamation.details && state.reclamation.details.qualifications ? state.reclamation.details.qualifications.depot : null,       
    isLoading: state.reclamation.details.isQualificationsLoading
});

const mapDispatchToProps = dispatch => ({
    fetchReclamationQualificationsIfNeeded: id => dispatch(fetchReclamationQualificationsIfNeeded(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(ErreurQuantiteDialogContentContainer);